import { useEffect } from "react";

import { useRadar } from "../context/RadarContext";

type SetTitleProps = {
  title: string;
  /** Set when the title already names the radar, to avoid "X | X". */
  standalone?: boolean;
};

export default function SetTitle({ title, standalone = false }: SetTitleProps) {
  const { descriptor } = useRadar();

  useEffect(() => {
    document.title = standalone ? title : `${title} | ${descriptor.name}`;
  }, [title, standalone, descriptor.name]);

  return null;
}
